/**
 * @generated SignedSource<<2b6f75448a7ba7acd2e2baf149013c32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowsAdditionalContentRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TimelineRowsContent">;
  readonly " $fragmentType": "RowsAdditionalContentRenderer";
};
export type RowsAdditionalContentRenderer$key = {
  readonly " $data"?: RowsAdditionalContentRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowsAdditionalContentRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "RowsAdditionalContentRenderer",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimelineRowsContent"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "fa60dcc2c4e7e90daa4d28978abe34b9";

export default node;
